import { useEffect, useState } from 'react';

// Schermo stretto (telefono / tablet in verticale): i portali passano al menu a scomparsa
const QUERY = '(max-width: 860px)';
export default function useIsMobile() {
  const [mobile, setMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const f = (e) => setMobile(e.matches);
    mq.addEventListener ? mq.addEventListener('change', f) : mq.addListener(f);
    return () => { mq.removeEventListener ? mq.removeEventListener('change', f) : mq.removeListener(f); };
  }, []);
  return mobile;
}
